import React from "react";
import StockMovementFlow from "../components/StockMovementFlow";

export default function Umlagerung() {
  return (
    <StockMovementFlow
      title="Umlagerung"
      color="violet"
      endpoint="/transfers"
      transfer
      showPrice={false}
      testIdPrefix="ul"
    />
  );
}
